import request from "@/utils/requestJSON";

export function getFAQDetail() {
  return request({
    url: "/storage/FAQ/FAQDetail.json",
    method: "get",
  });
}
